'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import { styled } from 'styled-components';
import { ImagePreviewTrashButton } from './ImagePreviewTrashButton';
const ImagePreviewContainer = styled.div.withConfig({
  componentId: "aui__sc-n8hn7x-0"
})(["background-image:url(\"data:image/svg+xml,%3Csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg' version='1.1'%3E%3Crect width='100%25' height='100%25' fill='none' rx='7.5' stroke='%23A5AAAF' stroke-width='1.5' stroke-linecap='round' stroke-dasharray='3 5'/%3E%3C/svg%3E\");&:hover{background-image:url(\"data:image/svg+xml,%3Csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg' version='1.1'%3E%3Crect width='100%25' height='100%25' fill='none' rx='7.5' stroke='%23000000' stroke-width='1.5' stroke-linecap='round' stroke-dasharray='3 5'/%3E%3C/svg%3E\");cursor:pointer;}background-repeat:no-repeat;background-color:transparent;border-radius:0.5rem;border:none;width:inherit;height:inherit;display:flex;position:relative;"]);
const ImagePreviewImage = styled.img.withConfig({
  componentId: "aui__sc-n8hn7x-1"
})(["width:calc(100% - 0.5rem);height:calc(100% - 0.25rem);margin:0.25rem;border-radius:0.5rem;"]);
export const ImagePreview = /*#__PURE__*/forwardRef(({
  imageSrc,
  onDeleteClick,
  ...rest
}, fRef) => {
  if (!imageSrc) return null;
  return /*#__PURE__*/React.createElement(ImagePreviewContainer, _extends({
    ref: fRef
  }, rest), /*#__PURE__*/React.createElement(ImagePreviewTrashButton, {
    onClick: onDeleteClick
  }), /*#__PURE__*/React.createElement(ImagePreviewImage, {
    src: imageSrc,
    alt: 'preview'
  }));
});